import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-admin-edit-operator-details',
  standalone: false,
  templateUrl: './admin-edit-operator-details.component.html',
  styleUrl: './admin-edit-operator-details.component.scss',
})
export class AdminEditOperatorDetailsComponent implements OnInit {
  airmenForm: FormGroup | any;
  emailMismatch: boolean = false;
  operatorData : any;
  disableBtn:boolean = true;
  isFtnAgentSearch?:boolean = true;
  isDeleteUser?:boolean

  constructor(
    private readonly fb: FormBuilder,
    public router: Router,
    private readonly config: DynamicDialogConfig,
    private readonly ref: DynamicDialogRef,
  ) {}

  ngOnInit(): void {
    this.operatorData = this.config?.data.dialogData;
    this.isFtnAgentSearch = this.config?.data.isFtnAgentSearch;
    this.isDeleteUser = this.config?.data?.isDeleteUser;
    this.airmenForm = this.fb.group({
      operatorFirstName: this.fb.control('', [
        Validators.pattern(/^[a-zA-Z'-][a-zA-Z\s'-]*$/),
      ]),
      operatorLastName: this.fb.control('', [
        Validators.pattern(/^[a-zA-Z'-][a-zA-Z\s'-]*$/),
      ]),
      operatorEmail: this.fb.control('', [
        Validators.pattern(
          /^[a-zA-Z0-9]+(?:[._-][a-zA-Z0-9]+)*@[a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:\.[a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*)*\.[a-zA-Z]{2,10}$/i
        ),
        this.forbiddenDomainValidator,
      ]),
      operatorDob: this.fb.control(''), // Validators.pattern(/^\d{2}\/\d{2}\/\d{4}$/)]),
      operatorFTN: this.fb.control('', [Validators.minLength(8), Validators.pattern(/^[AC]\d{0,7}$/)]),
      nNumber: this.fb.control('', [Validators.pattern(/^[0-9]*[0-9][A-Za-z0-9]*$/)]),
      serialNo: this.fb.control('', [Validators.pattern(/^[a-zA-Z0-9-]*$/)]),
      arOwnerName: this.fb.control('', [Validators.pattern(/^[a-zA-Z'-][a-zA-Z\s'-]*$/)])
    });
    if(this.isFtnAgentSearch){
      this.airmenForm?.get('operatorEmail').setValidators([Validators.required,
        Validators.pattern(
          /^[a-zA-Z0-9]+(?:[._-][a-zA-Z0-9]+)*@[a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:\.[a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*)*\.[a-zA-Z]{2,10}$/i
        ),
        this.forbiddenDomainValidator,]);
      this.airmenForm?.get('operatorDob').setValidators([Validators.required]);
      this.airmenForm?.get('operatorFTN').setValidators([Validators.required, Validators.minLength(8), Validators.pattern(/^[AC]\d{7}$/)]);
      this.airmenForm?.get('operatorFirstName').setValidators([Validators.required, Validators.pattern(/^[a-zA-Z'-][a-zA-Z\s'-]*$/)]);
      this.airmenForm?.get('operatorLastName').setValidators([Validators.required, Validators.pattern(/^[a-zA-Z'-][a-zA-Z\s'-]*$/)]);
    } else{
      this.airmenForm?.get('nNumber').setValidators([Validators.required, Validators.pattern(/^[0-9]*[0-9][A-Za-z0-9]*$/)]);
      this.airmenForm?.get('serialNo').setValidators([Validators.required, Validators.pattern(/^[a-zA-Z0-9-]*$/)]);
      this.airmenForm?.get('arOwnerName').setValidators([Validators.required, Validators.pattern(/^[a-zA-Z'-][a-zA-Z\s'-]*$/)]);
    }

    if(this.operatorData)
    {
       const dob = this.operatorData.operatorDob ? formatDate(this.operatorData.operatorDob, 'yyyy-MM-dd', 'en-US') : '';
       this.operatorData['operatorFirstName'] = this.operatorData['operatorFirstName']?.replace(this.operatorData?.operatorLastName, "");
       this.airmenForm.patchValue(this.operatorData);
       this.airmenForm.get('operatorDob')?.setValue(dob); 
    }
  }

  forbiddenDomainValidator(control: AbstractControl): ValidationErrors | null {
    const email: string = control.value || '';
    return email.endsWith('@faa.gov') ? { forbiddenDomain: true } : null;
  }

  onChange(event:any) {
    if(!this.airmenForm.valid){
      this.disableBtn = false
    }
  }

  saveForm(event?:Event)
  {
    if (this.airmenForm.valid ) {
      this.closeOperatorModal(false, event);  
    }else if (!this.airmenForm.valid){
      this.airmenForm.markAllAsTouched();
    }
  }
  deleteUser(){
    this.ref.close({isCancel:false});
  }

  closeOperatorModal(isCancel?:boolean, event?:Event) {
    this.ref.close({formData:this.airmenForm,isCancel:isCancel, event:event});
    event?.preventDefault();
  }
}
